module.exports = __webpack_public_path__ + "static/media/ivy2.da208f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/photos/ivy2.jpg
// module id = 205
// module chunks = 0